import React from 'react';
import { motion } from 'framer-motion';
import './Legal.css';

interface LegalProps {
  onBack?: () => void;
}

const Legal: React.FC<LegalProps> = ({ onBack }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className='legal-page'
    >
      <div className='container'>
        <div className='legal-content'>
          {onBack && (
            <button onClick={onBack} className='back-button'>
              ← Back
            </button>
          )}
          <h1>Legal</h1>

          <section>
            <h2>Company Information</h2>
            <p>
              Cinquity is a leading provider of clinical trial technology
              solutions, specializing in eCOA (electronic Clinical Outcome
              Assessment) platforms and clinical trial management systems.
            </p>
          </section>

          <section>
            <h2>Regulatory Compliance</h2>
            <p>
              Our products and services are designed to meet regulatory
              requirements including FDA 21 CFR Part 11, EudraLex Volume 10
              Clinical Trials Directive, ICH GCP guidelines, and other
              applicable clinical trial regulations worldwide.
            </p>
          </section>

          <section>
            <h2>Intellectual Property</h2>
            <p>
              All content, software, technology, and materials provided by
              Cinquity are proprietary and protected by copyright, trademark,
              and other intellectual property laws. Users may not reproduce,
              distribute, or create derivative works without explicit written
              permission.
            </p>
          </section>

          <section>
            <h2>Disclaimers</h2>
            <p>
              The information provided on this website is for informational
              purposes only and does not constitute medical advice. Our clinical
              trial services are tools to aid in research and should be used in
              conjunction with proper clinical supervision and regulatory
              approval.
            </p>
          </section>

          <section>
            <h2>Liabilities</h2>
            <p>
              Cinquity will not be liable for any indirect, incidental, special,
              or consequential damages arising from the use of our services,
              except where prohibited by law. Our liability is limited to the
              amount paid for our services.
            </p>
          </section>

          <section>
            <h2>Governing Law</h2>
            <p>
              These terms are governed by and construed in accordance with
              applicable laws. Any disputes arising from the use of our services
              will be resolved through appropriate legal channels.
            </p>
          </section>

          <div className='legal-footer'>
            <p>
              <strong>Last Updated:</strong> January 2025
            </p>
            <p>
              <strong>Legal Contact:</strong> legal@cinquity.com
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Legal;
